import React, { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import CalendarioComponent from "./CalendarioComponent";
import { useHistory, useParams } from "react-router-dom";
import CalendarioService from "../../services/CalendarioService.";
import ICalendario from "../../interfaces/ICalendario";
import Swal from 'sweetalert2';
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { LISTA_ESTADOS, TIPO_CALENDARIO } from "../../utils/Constants";
import ICalendarioFeriado from "../../interfaces/ICalendarioFeriado";
import { IMunicipioIBGE } from "../../interfaces/IMunicipioIBGE";
import IBGEService from "../../services/IBGEService";

const calendarBreadCrumbs: Array<PageLink> = [
    {
        title: 'Calendário',
        path: '/calendario',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: true,
    }
]

interface formParams extends ICalendario {
    nomeCalendario: string;
    tipo: string;
    estado: string;
    municipio: string;
    file: any;
    calendarioFeriados?: ICalendarioFeriado[]
}

function CalendarioNovo() {

    const intl = useIntl();
    const { classes } = useLayout();
    const { id } = useParams<{ id: string }>();
    const [paginaCarregada, setPaginaCarregada] = useState<boolean>(false);
    const history = useHistory();
    const initialValues: formParams = {
        nomeCalendario: '',
        tipo: '',
        estado: '',
        municipio: '',
        file: null,
        calendarioFeriados: []
    }
    const [municipios, setMunicipios] = useState<IMunicipioIBGE[]>([]);
    const calendarioSchema = Yup.object().shape({
        nomeCalendario: Yup.string()
            .min(3, 'Minimo 3 caracteres')
            .max(50, 'Maximo 50 caracteres')
            .required('Nome é obrigatório'),
        tipo: Yup.string().oneOf([TIPO_CALENDARIO.NACIONAL, TIPO_CALENDARIO.ESTADUAL, TIPO_CALENDARIO.MUNICIPAL]).required('Tipo calendário é obrigatório'),
        estado: Yup.string().max(2).min(2).test('validacao-estado', 'Estado somente é obrigatório quando tipo de Calendário é Estadual ou Municipal', async (value) => {
            if (formik.values.tipo === TIPO_CALENDARIO.NACIONAL) {
                return true;
            }

            if (value?.length) {
                return true;
            }

            return false;
        }),
        municipio: Yup.string().min(3).test('validacao-municipal', 'Municipio somente é obrigatório quando tipo de Calendário é Municipal', async (value) => {
            if (formik.values.tipo !== TIPO_CALENDARIO.MUNICIPAL) {
                return true;
            }

            if (formik.values.tipo === TIPO_CALENDARIO.MUNICIPAL && value) {
                return true;
            } else {
                return false;
            }
        })
    })
    const formik = useFormik({
        initialValues,
        validationSchema: calendarioSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {

                !id ? await CalendarioService.criar(values) : await CalendarioService.atualizar(values)

                setSubmitting(false);
                await Swal.fire({
                    text: 'Calendário salvo com sucesso',
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });

                history.push("/calendario");
            } catch (error) {
                setSubmitting(false)
                Swal.fire({
                    text: 'Não foi possivel salvar o calendário', //TODO: Tratar mensagem de erro
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
        }
    })

    useEffect(() => {
        async function preCarregar() {
            try {
                if (id != null) {
                    const cal = await CalendarioService.obterPorId(parseInt(id));
                    if (cal !== null) {
                        formik.setValues({ ...cal, file: null });
                    }
                }
                setPaginaCarregada(true);
            } catch (error) {
                console.log(error);
                await Swal.fire({
                    text: 'Não foi possivel carregar o calendário', //TODO: Tratar mensagem de erro
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
                history.push('/Calendario');
            }
        }

        preCarregar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    function atualizarFeriados(feriados: ICalendarioFeriado[]) {
        formik.setFieldValue('calendarioFeriados', feriados)
    }

    return <>
        <PageTitle pageBack="/calendario" breadcrumbs={calendarBreadCrumbs}>{intl.formatMessage({ id: 'MENU.CALENDAR' })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
                <div className='d-flex align-items-center py-1'>
                    <button type="submit" disabled={formik.isSubmitting || !formik.isValid} onClick={() => formik.submitForm()} className='btn btn-sm btn-primario'>
                        {
                            !formik.isSubmitting &&
                                <>
                                    <i className="text-white far fa-save"></i>
                                    <span style={{ verticalAlign: 'middle' }}>
                                        SALVAR
                                    </span>
                                </>
                        }
                        {
                            formik.isSubmitting && 
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Salvando...
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                        }
                    </button>
                </div>
            </div>
        </div>
        {
            paginaCarregada ?
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-agri-12 col-lg-3 mb-5">
                        <form
                            noValidate className="row g-3">
                            <div className="col-md-6">
                                <label htmlFor="nomeCalendario" className="form-label required">Nome do Calendário</label>
                                <input
                                    {...formik.getFieldProps('nomeCalendario')} name="nomeCalendario" placeholder="Digite Algo" type="text"
                                    className={clsx(
                                        'form-control',
                                        {
                                            'is-invalid': formik.touched.nomeCalendario && formik.errors.nomeCalendario
                                        },
                                        {
                                            'is-valid': formik.touched.nomeCalendario && !formik.errors.nomeCalendario
                                        }
                                    )} id="form-evento-nomedocalendario"
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="form-calendario-tipoferiado" className="form-label required">Tipos de Feriados</label>
                                <select
                                    {...formik.getFieldProps('tipo')} name="tipo"
                                    disabled={id != null}
                                    id="form-calendario-tipoferiado"
                                    onChange={async (e) => {
                                        await formik.setFieldValue(e.target.name, e.target.value);
                                        formik.setFieldTouched(e.target.name, true);

                                        formik.setFieldValue('estado', '');
                                        formik.setFieldTouched('estado', false);

                                        formik.setFieldValue('municipio', '');
                                        formik.setFieldTouched('municipio', false);

                                        setMunicipios([]);
                                    }}
                                    className={clsx(
                                        'form-select',
                                        {
                                            'is-invalid': formik.touched.tipo && formik.errors.tipo
                                        },
                                        {
                                            'is-valid': formik.touched.tipo && !formik.errors.tipo
                                        }
                                    )}>

                                    <option value="" hidden>Selecione</option>
                                    <option value={TIPO_CALENDARIO.NACIONAL}>{TIPO_CALENDARIO.NACIONAL}</option>
                                    <option value={TIPO_CALENDARIO.ESTADUAL}>{TIPO_CALENDARIO.ESTADUAL}</option>
                                    <option value={TIPO_CALENDARIO.MUNICIPAL}>{TIPO_CALENDARIO.MUNICIPAL}</option>
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="form-calendario-estados" className="form-label">Estado</label>
                                <select disabled={id != null || !(formik.values.tipo !== '' && formik.values.tipo !== TIPO_CALENDARIO.NACIONAL)} {...formik.getFieldProps('estado')} placeholder="Estado(UF)" id="form-calendario-estados"
                                    onChange={async e => {
                                        await formik.setFieldValue('estado', e.target.value);
                                        if (e.target.value && formik.values.tipo === TIPO_CALENDARIO.MUNICIPAL) {
                                            await IBGEService.pesquisarMunicipios(e.target.value, x => setMunicipios(x));
                                        }
                                    }}

                                    className={clsx(
                                        'form-select',
                                        {
                                            'is-invalid': formik.touched.estado && formik.errors.estado
                                        },
                                        {
                                            'is-valid': formik.touched.estado && !formik.errors.estado
                                        }
                                    )}

                                >
                                    <option value="" hidden>Selecione</option>
                                    {
                                        LISTA_ESTADOS.map((x, index) => <option value={x} key={index}>{x}</option>)
                                    }
                                </select>
                            </div>
                            {
                                id != null ? 
                                    <div className="col-md-6">
                                        <label htmlFor="form-calendario-municipio" className="form-label">Município</label>
                                        <input
                                            placeholder="Município"
                                            {...formik.getFieldProps('municipio')}
                                            type="text"
                                            className={clsx(
                                                'form-control',
                                                {
                                                    'is-invalid': formik.touched.municipio && formik.errors.municipio
                                                },
                                                {
                                                    'is-valid': formik.touched.municipio && !formik.errors.municipio
                                                }
                                            )}
                                            id="form-evento-estados"
                                            disabled={id != null || !(formik.values.tipo === TIPO_CALENDARIO.MUNICIPAL)} />
                                    </div>
                                :
                                    <div className="col-md-6">
                                        <label htmlFor="form-calendario-municipio" className="form-label">Município</label>
                                        <select disabled={id != null || !(formik.values.tipo === TIPO_CALENDARIO.MUNICIPAL) || formik.values.estado === ''} {...formik.getFieldProps('municipio')} placeholder="municipio" id="form-calendario-municipio"
                                            className={clsx(
                                                'form-select',
                                                {
                                                    'is-invalid': formik.touched.municipio && formik.errors.municipio
                                                },
                                                {
                                                    'is-valid': formik.touched.municipio && !formik.errors.municipio
                                                }
                                            )}>
                                            <option value="" hidden>Selecione</option>
                                            {
                                                municipios.map(x => <option value={x.nome} key={x.id}>{x.nome}</option>)
                                            }
                                        </select>
                                    </div>
                            }
                        </form>
                    </div>
                    <div className="col-md-12 col-sm-12 col-agri-12 col-lg-9">
                        <div className="row">
                            <CalendarioComponent calendarioID={id != null ? parseInt(id) : null} feriados={formik.values.calendarioFeriados} setFeriados={atualizarFeriados} />
                        </div>
                    </div>
                </div>
            :
                <p>Carregando...</p>
        }
    </>
}

export default CalendarioNovo;